export class RegionModel {
    Age;
    AreaSqMiles;
    BurdenBeasts;
    CastlesActive;
    get CastlesInCivilized() {
        return this.CastlesTotal - this.CastlesInOutskirts;
    }
    CastlesInOutskirts;
    CastlesRuined;
    CastlesTotal;
    Cities;
    Fowl;
    TotalLivestock;
    Towns;
    GetBigSettlements() {
        return this.Cities.concat(this.Towns);
    }
}
//# sourceMappingURL=region.js.map